<template>
  <div class="no-content" :class="classObject">
    <!-- <div class="no-content__icon-container">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 0C6.72 0 0 6.72 0 15C0 23.28 6.72 30 15 30C23.28 30 30 23.28 30 15C30 6.72 23.28 0 15 0ZM15 22.5C14.175 22.5 13.5 21.825 13.5 21V15C13.5 14.175 14.175 13.5 15 13.5C15.825 13.5 16.5 14.175 16.5 15V21C16.5 21.825 15.825 22.5 15 22.5ZM16.5 10.5H13.5V7.5H16.5V10.5Z"
          fill="#C7C7C7"
        />
      </svg>
    </div> -->
    <div v-if="twoLines" class="no-content__text-container">
      <p class="no-content__text">現在掲載されている</p>
      <p class="no-content__text">{{ text }}はありません</p>
    </div>
    <div v-else class="no-content__text-container">
      <p class="no-content__text">現在掲載されている{{ text }}はありません</p>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  text: {
    type: String,
    default: 'コンテンツ',
  },
  twoLines: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: 'dark', // [dark, light]
  },
})

const classObject = computed(() => {
  return {
    light: props.color === 'light',
  }
})
</script>

<style scoped lang="scss">
.no-content {
  color: $color-gray-text;
  font-size: 1.6rem;
  line-height: calc(24 / 16);
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $color-settings;
  &.light {
    color: $color-jan;
    font-weight: 500;
  }
}

.no-content__icon-container {
  height: 3rem;
  width: 3rem;
  margin-bottom: 1.6rem;
}

.no-content__text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.no-content__text {
  padding: 0;
}
</style>
